import { connect } from 'react-redux';

import { CollapsedContentProps } from 'src/components/sidebar';
import { scrollTo } from 'src/redux/global/actions/scroll-to';
import { updateSidebarState } from 'src/redux/sidebar';
import { getIsSiteMessageActive } from 'src/selectors/global-selectors';
import { BucketState, BucketDispatch } from 'src/types/state';

import Sidebar from '../components/sidebar';

const mapStateToProps = (state: BucketState) => ({
  isBannerOpen: getIsSiteMessageActive(state),
});

const mapDispatchToProps = (dispatch: BucketDispatch) => ({
  onCollapsedContentClick: (props: CollapsedContentProps) => {
    dispatch(
      updateSidebarState({
        isOpen: true,
        tabIndex: props.tabIndex,
        sidebarType: 'branch',
      })
    );
    setTimeout(() => dispatch(scrollTo({ targetId: props.id })), 200);
  },
});

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
